import React, { Component } from "react";

export class Header extends Component {
  render() {
    return (
      <header id="header">
        <div className="intro">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="col-md-8 col-md-offset-2 intro-text" >
                  <a
                    href="#features"
                    className="btn btn-custom btn-lg page-scroll"
                    style={{ marginBottom: "350px" }}
                  >
                    Daha Fazlası
                  </a>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
